import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MultipleSpinnerService } from '@core/services/common/multiple-spinner.service';
import { APP_CONFIG, MODULE } from '@core/configs';
import { LoginService } from '@core/services/apis/login.service';
import { CKPassLoginModel } from '@core/models/interfaces/login.interface';
import { environment } from '@environments/environment';
import { HTTP_STATUS } from '@core/configs/http-status.config';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dbs-login-dialog',
  styleUrls: ['./login-dialog.component.scss'],
  templateUrl: './login-dialog.component.html',
})
export class LoginDialogComponent {
  @ViewChild('form', { static: false }) form: NgForm;
  isError = false;
  isShowPassword = false;
  loginModel: CKPassLoginModel = { email: '', password: '', module: MODULE.careconneConsole };

  constructor(
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private multipleSpinnerService: MultipleSpinnerService,
    private loginService: LoginService,
  ) {

   }

  validation() {
    if(!this.loginModel.email || !this.loginModel.password) {
      return false;
    }
    return true;
  }

  onChangeCheckboxShowPassword($event) {
    this.isShowPassword = $event.checked;
  }

  async onLogin() {
    if (this.validation()) {
        try {
          this.multipleSpinnerService.show();
          this.isError = false;
          const res = await this.loginService.loginByCKPass(this.loginModel);
          if (res) {
            this.dialogRef.close(true);
          }
        } catch (error) {
          if (error?.error?.message === 'ERR_USER_LOCKED') {
            this.goPassLockAccountScreen();
            return;
          }
          if (error && error.status === HTTP_STATUS.unauthorized) {
            this.isError = true;
          }
        } finally {
          this.multipleSpinnerService.hide();
        }
    } else {
        this.isError = true;
    }
  }

  goForgotPassword() {
    window.location.href = environment.cKPassWebappUrl + 'forgot-password' + '?module=careconne-console';
  }

  goPassLockAccountScreen() {
    const url = new URL(environment.cKPassWebappUrl);
    url.pathname = 'blocked-user';
    url.searchParams.append('module', APP_CONFIG.module.toLowerCase());
    window.location.href = url.href;
  }
}
